<template>
  <div
    style="
      box-shadow: 0px 2px 10px rgba(232, 228, 230, 0.7);
      border-radius: 15px;
    "
  >
    <div
      style="
        background: #bee3d9;
        border-top-left-radius: 15px;
        border-top-right-radius: 15px;
      "
      class="d-flex align-center"
    >
      <h3
        style="font-size: 16px; font-weight: 700; word-wrap: break-word"
        class="px-3 py-2"
      >
        {{ label }}
      </h3>
      <a
        class="ml-auto mr-2"
        @click.stop="dialog = true"
        v-if="isCustom && editable"
      >
        <v-icon>mdi-close</v-icon>
      </a>
      <v-dialog v-model="dialog" width="434">
        <v-card>
          <v-card-title></v-card-title>
          <v-card-text>
            <p>
              Apakah Anda yakin ingin menghapus informasi ini? Tindakan ini
              tidak dapat dibatalkan.
            </p></v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                $emit('closeCard');
              "
            >
              Ya
            </v-btn>
            <v-btn color="red" text @click="dialog = false"> Tidak</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
    <div>
      <v-text-field
        v-if="
          editable &&
          label != 'Seksi' &&
          label != 'Kategori Utama' &&
          label != 'Tahun Perolehan' &&
          label != 'Nomor Urut Barang' &&
          label != 'Kode Barang' &&
          label != 'Kode Lokasi'
        "
        class="px-3 py-2"
        style="font-size: 14px; font-weight: 400; word-wrap: break-word"
        :value="value"
        :placeholder="placeholder"
        @input="updateValue"
        :rules="rules"
        :maxlength="maxLength"
      ></v-text-field>
      <v-select
        v-else-if="editable && label === 'Seksi'"
        class="px-3 py-2"
        style="font-size: 14px; font-weight: 400; word-wrap: break-word"
        :items="['1A', '2A', '2B']"
        :label="value || label"
        @input="updateValue"
        :rules="rules"
        single-line
      ></v-select>
      <v-select
        v-else-if="editable && label === 'Kategori Utama'"
        class="px-3 py-2"
        style="font-size: 14px; font-weight: 400; word-wrap: break-word"
        :items="[
          'Tanah Rumpun Jalan dan Transportasi',
          'Peralatan dan Mesin Rumpun Jalan dan Transportasi',
          'Gedung dan Bangunan Rumpun Jalan dan Transportasi',
          'Jalan Irigasi dan Jaringan Rumpun Jalan dan Transportasi',
          'Aset Tak Berwujud Rumpun Jalan dan Transportasi',
        ]"
        :label="value || label"
        :rules="rules"
        @input="updateValue"
        single-line
      ></v-select>
      <v-menu
        v-else-if="editable && label === 'Tahun Perolehan'"
        ref="menu"
        v-model="menu"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
            v-bind="attrs"
            v-on="on"
            class="px-3 py-2"
            style="font-size: 14px; font-weight: 400; word-wrap: break-word"
            :value="toDisplayFormat(date)"
            :placeholder="placeholder"
            readonly
            :rules="rules"
          ></v-text-field>
        </template>
        <v-date-picker
          v-model="date"
          type="month"
          @input="onDateInput"
          :max="maxDate"
          color="primary"
          scrollable
        ></v-date-picker>
      </v-menu>
      <h5
        v-else
        class="px-3 py-2"
        style="font-size: 14px; font-weight: 400; word-wrap: break-word"
      >
        {{ label === "Nilai Perolehan" ? formatRupiah(value) : value || "-" }}
      </h5>
    </div>
  </div>
</template>

<script>
import { formatRupiah } from "@/plugins/helpers";

export default {
  props: {
    label: String,
    value: [String, Number],
    editable: Boolean,
    isCustom: Boolean,
    placeholder: String,
    rules: [],
    maxLength: {
      type: Number,
      default: null,
      required: false,
    },
  },
  data() {
    return {
      dialog: false,
      menu: false,
      date: this.value ? this.toPickerFormat(this.value) : null,
    };
  },
  watch: {
    value(val) {
      this.date = val ? this.toPickerFormat(val) : null;
    },
  },
  methods: {
    updateValue(newValue) {
      this.$emit("input", newValue);
    },
    onDateInput(val) {
      this.date = val;
      this.$emit("input", this.toDisplayFormat(val));
      this.menu = false;
    },
    toPickerFormat(val) {
      // Convert mm-yyyy to yyyy-mm for v-date-picker
      if (val && /^\d{2}-\d{4}$/.test(val)) {
        const [mm, yyyy] = val.split("-");
        return `${yyyy}-${mm}`;
      }
      return val;
    },
    toDisplayFormat(val) {
      // Convert yyyy-mm to mm-yyyy for displaying to user
      if (val && /^\d{4}-\d{2}$/.test(val)) {
        const [yyyy, mm] = val.split("-");
        return `${mm}-${yyyy}`;
      }
      return val;
    },
    formatRupiah,
  },
  computed: {
    maxDate() {
      return new Date().toISOString().substr(0, 10);
    },
  },
};
</script>
